import React from 'react';

import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const BULLET_LINE_RE = /^([-*•]|\d+[.)])\s+(.*)$/;
const HEADING_LINE_RE = /^(.+):$/;
const isLikelyStandaloneHeading = (line, nextLine) => {
  if (!nextLine) return false;
  if (!BULLET_LINE_RE.test(nextLine)) return false;
  if (/[.!?]$/.test(line)) return false;
  return line.split(/\s+/).filter(Boolean).length <= 6;
};

const renderInlineText = text =>
  richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

const parseOverviewSections = text => {
  const lines = text
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);

  const sections = [];
  let currentSection = { title: null, paragraphs: [], bullets: [] };

  const flushSection = () => {
    if (currentSection.title || currentSection.paragraphs.length > 0 || currentSection.bullets.length > 0) {
      sections.push(currentSection);
    }
    currentSection = { title: null, paragraphs: [], bullets: [] };
  };

  lines.forEach((line, index) => {
    const nextLine = lines[index + 1];
    const headingMatch = line.match(HEADING_LINE_RE);
    const bulletMatch = line.match(BULLET_LINE_RE);

    if (headingMatch || (!bulletMatch && isLikelyStandaloneHeading(line, nextLine))) {
      flushSection();
      currentSection.title = headingMatch ? headingMatch[1].trim() : line.trim();
      return;
    }

    if (bulletMatch) {
      currentSection.bullets.push(bulletMatch[2].trim());
      return;
    }

    currentSection.paragraphs.push(line);
  });

  flushSection();
  return sections;
};

const SectionOverviewMaybe = ({ text }) => {
  if (!text) return null;

  const sections = parseOverviewSections(text);

  return (
    <section className={css.sectionOverview}>
      {sections.map((section, sectionIndex) => (
        <div key={`${section.title || 'section'}-${sectionIndex}`} className={css.overviewBlock}>
          {section.title ? (
            <h3 className={css.overviewBlockTitle}>{section.title}</h3>
          ) : null}

          {section.paragraphs.map((paragraph, paragraphIndex) => (
            <p
              key={`${sectionIndex}-p-${paragraphIndex}`}
              className={css.overviewParagraph}
            >
              {renderInlineText(paragraph)}
            </p>
          ))}

          {section.bullets.length > 0 ? (
            <ul className={css.overviewList}>
              {section.bullets.map((bullet, bulletIndex) => (
                <li key={`${sectionIndex}-b-${bulletIndex}`} className={css.overviewListItem}>
                  {renderInlineText(bullet)}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      ))}
    </section>
  );
};

export default SectionOverviewMaybe;
